import React, { useEffect, useState } from "react";
import axios from "axios";
import "./styles/UserStatus.css";
import { CiCloudOn, CiCloudOff } from "react-icons/ci";
import { FiUsers } from "react-icons/fi";
import Registeduser from "../assets/Registeduser.png"
import { GrUserExpert } from "react-icons/gr";
import { FaUserCircle } from "react-icons/fa";
import { IoMdCloudOutline } from "react-icons/io";
import { MdCloudOff } from "react-icons/md";
import openNotification from "components/utils/CustomNotification";
import { SessionExtend } from "components/utils/SessionCheckUtils";
import { useCheckSessionHeartBeat } from "components/API/ApiEnpoints";

interface Teams {
  org_uid: string;
  group_uid: string;
  group_name: string;
  group_type: string;
  description: string;
  code: string | null;
  status: string;
  reason: string;
  source: string;
  created_at: string;
  created_by: string;
  visibility?: string;
  updated_at: string | null;
  updated_by: string | null;
  users_count: number;
  active_users: number;
}
interface Leader {
  user_uid: string;
  user_name: string;
  name: string;
  department: string;
  project: string;
  job_title: string;
  group_uid: string;
}
interface GroupItem {
  group_name: string;
  group_uid: string;
  is_member: boolean;
}

interface GroupFilters {
  department: GroupItem[];
  location: GroupItem[];
  projectteam: GroupItem[];
  Custom?: GroupItem[];
  clientteam: GroupItem[];
}
const UserStatus: React.FC = () => {
  useCheckSessionHeartBeat();
  const sessionUid = localStorage.getItem("session_uid") || "";
  const userUid = localStorage.getItem("user_uid") || "";
  const beAddress =
    window._env_?.REACT_APP_API_URL || process.env.REACT_APP_API_URL;

  const [search, setSearch] = useState("");
  const [users, setUsers] = useState<any[]>([]);
  const [totalCount, setTotalCount] = useState(0);
  const [onlineCount, setOnlineCount] = useState(0);
  const [offlineCount, setOfflineCount] = useState(0);
  const [registeredUsers, setRegisteredUsers] = useState(0);
  const [statusFilter, setStatusFilter] = useState<string | undefined>(undefined);
  const [inactiveFilter, setInactiveFilter] = useState<number | undefined>(undefined);
  const [currentPage, setCurrentPage] = useState(1);
  const [leaders, setLeaders] = useState<Leader[]>([]);
  const usersPerPage = 10;
  const [userImages, setUserImages] = useState<Record<string, string>>({});
  const [teams, setTeams] = useState<Teams[]>([]);
  const [selectedTeams, setSelectedTeams] = useState<Teams[]>([]);
  const [groupFilters, setGroupFilters] = useState<GroupFilters>({
    department: [],
    location: [],
    projectteam: [],
    clientteam: [],
  });
  const [myTeamUids, setMyTeamUids] = useState<string[]>([]);
  const [noTeams, setNoTeams] = useState(false);
  const [loading, setLoading] = useState(true);
  const [selectedTeamUid, setSelectedTeamUid] = useState<string | undefined>(undefined);


  const filteredUsers = users.filter((u) => {
    const fullName = `${u.first_name} ${u.last_name}`.toLowerCase();
    const jobTitle = u.job_title?.toLowerCase() || "";
    const searchTerm = search.toLowerCase();

    return fullName.includes(searchTerm) || jobTitle.includes(searchTerm);
  });


  const totalPages = Math.ceil(filteredUsers.length / usersPerPage);
  const indexOfLastUser = currentPage * usersPerPage;
  const indexOfFirstUser = indexOfLastUser - usersPerPage;
  const currentUsers = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  useEffect(() => {
    setCurrentPage(1);
  }, [users]);


  const fetchUserOnlineStatus = async () => {
    try {
      const response = await axios.get(`${beAddress}/api/user-online-status`, {
        headers: {
          "user-uid": userUid,
        },
        params: {
          inactive_period: inactiveFilter,
          user_online_status: statusFilter,
          group_uid: selectedTeamUid,
        },withCredentials: true,
      });

      // check for success API response
      if (response.status === 200 && response.data?.status === "Success") {
        const apiUsers = response.data?.data?.user_records || [];

        if (apiUsers.length === 0) {
          setUsers([]);
          setTotalCount(response.data?.data?.total_users || 0);
          setRegisteredUsers(response.data?.data?.registered_users || 0);
          setOnlineCount(response.data?.data?.online_user_count || 0);
          setOfflineCount(response.data?.data?.offline_user_count || 0);

          openNotification({
            type: "info",
            message: "No users found",
          });

          return; // stop further execution
        }

        const formattedUsers = apiUsers.map((user: any) => {
          const utcDate = user.last_active;
          const localDate = utcDate
            ? new Date(utcDate).toLocaleString()
            : "—";
          return { ...user, last_active: localDate, user_status: user.user_status || user.user_online_status || user.status, };
        });

        // ⬇ extract all image UIDs from USERS, not just current page
        setUsers(formattedUsers);

        setTotalCount(response.data?.data?.total_users || 0);
        setRegisteredUsers(response.data?.data?.registered_users || 0);
        setOnlineCount(response.data?.data?.online_user_count || 0);
        setOfflineCount(response.data?.data?.offline_user_count || 0);


        // openNotification({
        //   type: "success",
        //   message: response.data?.message || "User status fetched successfully!",
        // });
      } else {

        openNotification({
          type: "error",
          message:
            response.data?.data ||
            "Failed to fetch user status!",
        });
      }
    } catch (error: any) {
      console.error("API error", error);

      openNotification({
        type: "error",
        message:
          error?.response?.data?.message ||
          error?.response?.data?.data ||
          "Something went wrong!",
      });
    }
  };


  useEffect(() => {
    if (!selectedTeamUid) return;
    fetchUserOnlineStatus();
  }, [inactiveFilter, statusFilter, selectedTeamUid]);

  useEffect(() => {
    const imageUids = currentUsers
      .filter((u) => u.image_details?.image_uid)
      .map((u) => u.image_details.image_uid);


    // If no custom images in this page → skip API
    if (imageUids.length === 0) return;

    fetchImagesByUid(imageUids).then((imageMap) => {
      setUserImages((prev) => ({ ...prev, ...imageMap }));
    });
  }, [currentPage, users]);


  const fetchImagesByUid = async (
    imageUids: string[]
  ): Promise<Record<string, string>> => {
    // Ensure max 10 at a time
    // const limitedUids = imageUids.slice(0, 10);
    const limitedUids = imageUids;


    if (limitedUids.length === 0) return {};

    try {
      const url = new URL(`${beAddress}/api/get-image-by-uid`);

      limitedUids.forEach((uid) =>
        url.searchParams.append("image_uid_list", uid)
      );
      url.searchParams.set("is_icon_img", "true");
      url.searchParams.set("is_feedback_image", "false");

      const res = await fetch(url.toString(), {
        headers: {
          "user-uid": userUid,
        },credentials: "include",
      });

      const data = await res.json();

      if (data.status === "Success" && Array.isArray(data.data)) {
        return Object.fromEntries(
          data.data.map((item: any) => [
            item.image_uid,
            `data:image/png;base64,${item.image}`  // always use returned Base64
          ])
        );

      }
    } catch (err) {
      console.error("Failed to fetch images:", err);
    }

    return {};
  };


  //const filteredUsers = [...users]; // same result but keeps naming consistent

  const paginate = (page: number) => {
    if (page < 1 || page > totalPages) return;
    setCurrentPage(page);
  };

  const fetchGroupFilters = async () => {
    try {
      const response = await axios.get(`${beAddress}/api/get-groups-filter`, {
        headers: {
          "user-uid": userUid!,
        },withCredentials: true,
      });

      if (response.data.status === "Success") {
        const filterData = response.data.data;
        setGroupFilters(filterData);
        const defaultTeam = filterData.location?.find((t: GroupItem) => t.group_name === "Karkala");

        if (defaultTeam) {
          setSelectedTeamUid(defaultTeam.group_uid);
        }

        setLeaders(filterData.Leaders);

        const myTeamGroupUids: string[] = filterData.my_teams || [];
        setMyTeamUids(myTeamGroupUids);

        if (myTeamGroupUids.length > 0) {
          //getOrgTeamsMetrics(myTeamGroupUids, false);
          setNoTeams(false);
          setTeams(filterData.my_teams);
        } else {
          setTeams([]);
          setNoTeams(true);
          // openNotification({
          //   type: "info",
          //   message: "No teams found in your group filters.",
          // });
        }

        setLoading(false);
      } else {
        openNotification({
          type: "error",
          message: response.data.data,
        });
        setTeams([]);
        setNoTeams(true);
        setLoading(false);
      }

      SessionExtend();
    } catch (err) {
      openNotification({
        type: "error",
        message: "Could not fetch teams or group filters. Please try again.",
      });
      setTeams([]);
      setNoTeams(true);
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchGroupFilters();
  }, []);


  return (
    <div className="user-status-container">
      {/* Status Count Section */}
      <h2 className="page-title">User Online Status</h2>
      <div className="status-main-card">
        <div className="status-item">
          <div className="status-icon"><FiUsers /></div>
          <h3>{totalCount}</h3>
          <p>Total Users</p>
        </div>

        <div className="status-item">
          <div className="status-icon"><GrUserExpert /></div>
          <h3 style={{ color: "var(--text-color)" }}>{registeredUsers}</h3>
          <p style={{ color: "var(--text-color)" }}>Registered Users</p>
        </div>

        <div className="status-item">
          <div className="status-icon"><IoMdCloudOutline /></div>
          <h3>{onlineCount}</h3>
          <p>Online</p>
        </div>

        <div className="status-item">
          <div className="status-icon"><MdCloudOff /></div>
          <h3>{offlineCount}</h3>
          <p>Offline</p>
        </div>
      </div>



      {/* Table Section */}
      <div className="users-table-wrapper">
        <div className="users-table-header">
          <h3 style={{ color: "var(--text-color)" }}>Registered Users</h3>
          <div className="users-table-controls">
            <input
              className="search-input"
              placeholder="Search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            {/* <select className="filter-select">
              <option>Inactive Since: 5 Days</option>
            </select> */}
            <select
              className="filter-select"
              value={selectedTeamUid}
              onChange={(e) => setSelectedTeamUid(e.target.value)}
            >
              {/* <option value="">All Teams</option> */}
              {groupFilters.location?.map((team) => (
                <option key={team.group_uid} value={team.group_uid}>
                  {team.group_name}
                </option>
              ))}
            </select>

          </div>
        </div>

        <table className="users-table">
          <thead>
            <tr>
              <th></th>
              <th>Name</th>
              <th>Job Title</th>
              <th>Last Active</th>
              <th>Last Inactive Since</th>
            </tr>
          </thead>

          <tbody>
            {
              currentUsers.length === 0 ? (
                <tr>
                  <td colSpan={5} style={{ textAlign: "center", padding: "20px" }}>
                    No users found
                  </td>
                </tr>
              ) : (
                currentUsers.map((u, idx) => (
                  <tr key={idx}>
                    <td>
                      <div className="avatar-wrapper">
                        {(() => {
                          const imgUid = u.image_details?.image_uid;
                          const displayImage =
                            u.profile_image || (imgUid && userImages[imgUid]) || "";

                          return displayImage ? (
                            <img src={displayImage} className="user-avatar" alt="User" />
                          ) : (
                            <FaUserCircle className="user-avatar" />
                          );
                        })()}
                        <span className={`status-dot ${u.user_status}`}></span>
                      </div>

                    </td>

                    {/* Name column */}
                    <td> {u.first_name} {u.last_name}</td>

                    <td>{u.job_title}</td>
                    <td>{u.last_active}</td>
                    <td>{u.inactive_period}</td>
                  </tr>
                ))
              )}
          </tbody>
        </table>

        <div className="UserList-pagination">
          <button
            className="UserList-pagination-button"
            onClick={() => paginate(currentPage - 1)}
            disabled={currentPage === 1}
          >
            Previous
          </button>

          <span className="page-indicator">
            Page {currentPage} of {totalPages}
          </span>

          <button
            className="UserList-pagination-button"
            onClick={() => paginate(currentPage + 1)}
            disabled={currentPage >= totalPages}
          >
            Next
          </button>
        </div>

      </div>
    </div >
  );
};

export default UserStatus;
